import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { useStyles } from '../useStyles';
import { useFilters } from '../../Provider';

const LotStatusesFilter: React.FC = () => {
  const { t } = useTranslation('tenders');
  const theme = useTheme();
  const { classes } = useStyles({ theme });
  const { selectedFilters, setField, lotStatuses } = useFilters();

  const current = selectedFilters.status;

  const handleToggleStatus = (id: string) => {
    const newStatuses = current?.includes(id)
      ? current?.filter((s) => s !== id)
      : [...(current ?? []), id];
    setField('status', newStatuses);
  };

  const handleResetStatuses = () => {
    setField('status', []);
  };

  return (
    <Stack
      direction={{ lg: 'row', md: 'column', xs: 'column' }}
      mt={3.75}
      gap={{ xs: 1.25, lg: 2.5 }}
    >
      <Typography width="100%" maxWidth={120} fontWeight={700}>
        {t('tenders.modal.status')}
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={1.25}>
        <Box
          key="any"
          className={clsx(classes.filter, {
            [classes.selectedFilter]: current?.length === 0,
          })}
          sx={{
            border: '1px solid',
            borderColor: current?.length === 0 ? 'primary.main' : 'grey.500',
            backgroundColor: 'white',
            cursor: 'pointer',
          }}
          onClick={handleResetStatuses}
        >
          <Typography color="grey.500">{t('tenders.lotType.any')}</Typography>
        </Box>

        {lotStatuses?.map((status) => {
          const id = String(status.id);
          const isSelected = current?.includes(id);
          return (
            <Box
              key={id}
              className={clsx(classes.filter, {
                [classes.selectedFilter]: isSelected,
              })}
              sx={{
                border: '1px solid',
                borderColor: isSelected ? 'primary.main' : 'grey.500',
                backgroundColor: 'white',
                cursor: 'pointer',
              }}
              onClick={() => handleToggleStatus(id)}
            >
              <Typography>{status.name}</Typography>
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default LotStatusesFilter;
